<template>
  <div style="padding: 25px; width: 100%">
    <h1>{{ TrainingName }}</h1>
    <iframe
      :src="RedirectLink"
      width="100%"
      height="1000px"
      frameborder="0"
      allowfullscreen
    ></iframe>

    <div style="padding: 20px">
      <p>Duration: {{ Duration }} minutes</p>
    </div>
    <div v-html="Description"></div>
  </div>
</template>

<script>
export default {
  props: {
    Category: {
      type: String,
    },
    Description: {
      type: String,
    },
    Duration: {
      type: Number,
    },
    Image: {
      type: String,
    },
    RedirectLink: {
      type: String,
    },
    TrainingName: {
      type: String,
    },
  },
  data() {
    return {
      showInfo: false,
    };
  },
  mounted() {
    if (!this.RedirectLink) {
      this.$router.push({
        name: 'vizgoCategoryDetail',
        params: { id: 1 },
      });
    }
  },
};
</script>
